import { render, staticRenderFns } from "./DialogForm.vue?vue&type=template&id=7a8a5fec"
import script from "./DialogForm.vue?vue&type=script&lang=js"
export * from "./DialogForm.vue?vue&type=script&lang=js"
import style0 from "./DialogForm.vue?vue&type=style&index=0&id=7a8a5fec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports